module.exports = __webpack_public_path__ + "img/charity_22.93bd8355.png";